import type {CardResult, _CardResult} from './../card-result';
import type {Card} from './../card';
import type {SummaryCardBuilder} from './../common/summary-card-builder';
import type {_BivariateCard} from './../bivariate-card';

/**
 * Generated from com.dataiku.dip.eda.worksheets.cards.bivariate_header.BivariateSummaryStatsCard
 */
export interface BivariateSummaryStatsCard extends _BivariateCard {
    compute: BivariateSummaryStatsCard.StatsToCompute;
    confidenceLevel: number;
    showConfidenceInterval: boolean;

    // PolyJson type
    type: 'bivariate_summary';
}

export namespace BivariateSummaryStatsCard {
    export const type = 'bivariate_summary';
}

/** @deprecated Use Card.isBivariateSummaryStatsCard() */ export function isBivariateSummaryStatsCard(toTest: Card): toTest is BivariateSummaryStatsCard { return BivariateSummaryStatsCard.type === toTest['type']; }

export namespace BivariateSummaryStatsCard {
    /**
     * Generated from com.dataiku.dip.eda.worksheets.cards.bivariate_header.BivariateSummaryStatsCard$BivariateSummaryStatsCardResult
     */
    export interface BivariateSummaryStatsCardResult extends _CardResult {
        stats: SummaryCardBuilder.ComputedStat[];

        // PolyJson type
        type: 'bivariate_summary';
    }

    export namespace BivariateSummaryStatsCardResult {
        export const type = 'bivariate_summary';
    }

    /** @deprecated Use CardResult.isBivariateSummaryStatsCardResult() */ export function isBivariateSummaryStatsCardResult(toTest: CardResult): toTest is BivariateSummaryStatsCardResult { return BivariateSummaryStatsCardResult.type === toTest['type']; }

    /**
     * Generated from com.dataiku.dip.eda.worksheets.cards.bivariate_header.BivariateSummaryStatsCard$StatsToCompute
     */
    export interface StatsToCompute {
        chi2: boolean;
        completeCount: boolean;
        covariance: boolean;
        kendallTau: boolean;
        kolmogorovSmirnov: boolean;
        mutualInformation: boolean;
        nSampleMood: boolean;
        oneWayAnova: boolean;
        pearson: boolean;
        spearman: boolean;
        totalCount: boolean;
    }
}